<template>
  <div class="pb-page narrow hv">
    <PageHeader title="Help" subtitle="How to put testimonials on your site, how permission works, and how to reach us." />

    <section class="pb-card hv-card" aria-labelledby="hv-install">
      <h2 id="hv-install" class="pb-section-title display-font hv-h">Put the widget on your website</h2>
      <p class="pb-body hv-lead">Copy your widget's code from <router-link to="/widgets">Widgets</router-link>, then paste it where the testimonials should appear.</p>
      <InstallGuide />
    </section>

    <section class="hv-faq" aria-labelledby="hv-q">
      <h2 id="hv-q" class="pb-section-title display-font hv-h">Questions</h2>
      <details v-for="item in faq" :key="item.question" class="pb-card flat hv-item">
        <summary class="hv-summary">{{ item.question }}<i class="mdi mdi-chevron-down" aria-hidden="true"></i></summary>
        <!-- Static answers from config.js (trusted product copy). -->
        <div class="hv-answer" v-html="item.answer"></div>
      </details>
    </section>

    <section id="contact" class="pb-card hv-card" aria-labelledby="hv-contact">
      <h2 id="hv-contact" class="pb-section-title display-font hv-h">Still stuck?</h2>
      <p class="pb-body">{{ member ? 'Write to us here, or email' : 'Email' }} <a :href="'mailto:' + $config.SUPPORT_EMAIL">{{ $config.SUPPORT_EMAIL }}</a>. We usually answer within a working day.</p>
      <form v-if="member" class="hv-form" @submit.prevent="send">
        <div class="pb-field"><label class="pb-label" for="hv-topic">What do you need?</label>
          <select id="hv-topic" v-model="topic" class="pb-select hv-topic">
            <option value="question">A question</option><option value="problem">Something is not working</option>
            <option value="billing">Billing or a refund</option><option value="data_export">A copy of my data</option>
            <option value="account_erasure">Delete my account and data</option></select></div>
        <p v-if="topic === 'data_export' || topic === 'account_erasure'" class="pb-note"><i class="mdi mdi-shield-account-outline pb-ico" aria-hidden="true"></i>
          <span>A person checks that the request is really yours before anything is copied or deleted, so it doesn't happen at once.
            <template v-if="topic === 'data_export'"> For your feedback itself, the CSV export in Settings works any time.</template></span></p>
        <div class="pb-field"><label class="pb-label" for="hv-text">Message</label>
          <textarea id="hv-text" v-model="text" class="pb-textarea" rows="4" maxlength="4000" placeholder="Tell us what happened, and the brand it's about."></textarea></div>
        <div class="pb-actions">
          <button type="submit" class="pb-button" :disabled="busy || text.trim().length < 10">{{ busy ? 'Sending…' : 'Send' }}</button>
          <span v-if="sent" class="pb-muted" role="status">{{ sent }}</span>
        </div>
        <div v-if="error" class="pb-alert is-error" role="alert"><span>{{ error }}</span></div>
      </form>
    </section>
  </div>
</template>

<script>
import InstallGuide from '../components/InstallGuide.vue';
import PageHeader from '../components/PageHeader.vue';
import { post, message } from '../api';

export default {
  name: 'HelpView',
  components: { InstallGuide, PageHeader },
  data: () => ({ topic: 'question', text: '', busy: false, sent: '', error: '' }),
  computed: {
    faq() { return (this.$config && this.$config.FAQ_ITEMS) || []; },
    member() { const user = this.$store.getters.currentUser; return !!(this.$store.getters.isAuthenticated && user && !user.is_anonymous); }
  },
  methods: {
    async send() {
      this.busy = true;
      this.error = '';
      this.sent = '';
      try {
        await post('/support', { topic: this.topic, message: this.text.trim() });
        this.text = '';
        this.sent = 'Sent. We\'ll reply by email.';
      } catch (error) { this.error = message(error); } finally { this.busy = false; }
    }
  }
};
</script>

<style scoped>
.hv-card{margin-bottom:22px}
.hv-h{margin-bottom:12px}
.hv-lead{margin-bottom:16px}
.hv-faq{margin-bottom:22px}
.hv-item{padding:0;margin-bottom:8px}
.hv-summary{display:flex;justify-content:space-between;align-items:center;gap:12px;min-height:56px;padding:12px 18px;cursor:pointer;list-style:none;
  font:600 15.5px/1.4 var(--font-body);color:#1F2328}
.hv-summary::-webkit-details-marker{display:none}
.hv-summary .mdi{font-size:22px;color:#963A22;transition:transform .2s ease}
details[open] .hv-summary .mdi{transform:rotate(180deg)}
.hv-answer{padding:0 18px 16px;color:#4F4A45;line-height:1.65;font-size:15px}
.hv-answer ::v-deep p{margin:0}
.hv-form{margin-top:16px}
.hv-topic{max-width:360px}
@media(prefers-reduced-motion:reduce){.hv-summary .mdi{transition:none}}
</style>
